import React from 'react';
import { userCircle } from '@amzn/storm-ui-icons';
import {
  IA2MobileUserIcon,
  MobileSideNavItemText,
  MoreToolsMenuItem,
} from './styles';
import { useSidenavBundle } from 'src/providers/PantherLocalizationProvider';
import { getTaktAttributes } from 'src/commons/utils/logWithTakt';
import { chromeComponents } from 'src/constants';

interface UserPreferenceMenuItemProps {
  handleClick: () => void;
}

export const UserPreferenceMenuItem: React.VFC<UserPreferenceMenuItemProps> = ({
  handleClick,
}) => {
  const bundle = useSidenavBundle();

  return (
    <MoreToolsMenuItem
      onClick={handleClick}
      aria-label={bundle.getMessage('sidenav-your-preferences-label')}
      data-ccx-e2e-id="aac-user-preferences"
      {...getTaktAttributes('aac-user-preferences', chromeComponents.NAV)}
    >
      <IA2MobileUserIcon type={userCircle} size="large" />
      <MobileSideNavItemText>
        {bundle.getMessage('sidenav-your-preferences-label')}
      </MobileSideNavItemText>
    </MoreToolsMenuItem>
  );
};
